import React from "react";
import { createCallable } from "react-call";
import EdgenDrawer, { EdgenDrawerProps } from "../Drawer";

export type EdgenDrawerCallableProps = Omit<
  EdgenDrawerProps,
  "isOpen" | "onClose"
> & {
  onClose?: () => void;
  isOpen?: boolean;
};

/**
 * 可调用的 EdgenDrawer 基础组件
 * 在 RootLayoutClient 中初始化 root，所有 Drawer 弹窗共享此 root
 * timeout 设置为 300，与 EdgenModalCreateAble 共享相同配置
 */
export const EdgenDrawerCallable = createCallable<
  EdgenDrawerCallableProps,
  boolean
>(({ call, onClose, ...props }) => {
  const isDestoryContent = typeof props?.isOpen === "undefined";
  const handleClose = () => {
    onClose?.();
    isDestoryContent && call.end(false);
  };
  const isOpen = !isDestoryContent ? !!props?.isOpen : !call.ended;

  return <EdgenDrawer isOpen={isOpen} onClose={handleClose} {...props} />;
}, 300);

export default EdgenDrawerCallable;
